<template>
  <div class="error-page">
      <div class="home card"><img class="home-bg" src="@/assets/img/welcome.png" alt="welcome"></div>
      <el-button circle class="error-btn" type="primary" size="large" @click="goBack" icon='el-icon-s-help'></el-button>
  </div>
</template>

<script>
export default {
  methods: {
      goBack(){
          this.$router.push('/dataNav');
      }
  }
}
</script>


<style scoped>
.home {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}
.card {
    box-sizing: border-box;
    padding: 20px;
    overflow-x: hidden;
    background-color: var(--top_bgcolor);
    border: 1px solid var(--top_bgcolor);
    border-radius: 6px;
    box-shadow: 0 0 12px #0000000d;
}
.home .home-bg{
    width: 80%;
    margin-top:-100px;
    max-width: 1200px;
    margin-bottom: 20px;
}
    .error-page{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
        height: 100%;
        background: #f3f3f3;
        box-sizing: border-box;
    }
    .error-code{
        line-height: 1;
        font-size: 250px;
        font-weight: bolder;
        color: #2d8cf0;
    }
    .error-code span{
        color: #00a854;
    }
    .error-desc{
        font-size: 30px;
        color: #777;
    }
    .error-handle{
        margin-top: 30px;
        padding-bottom: 200px;
    }
    .error-btn{
        position: fixed;
        top:50%;
        right:20px;

    }
</style>
